import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = {
  // 周星礼物配置
  config_gift_durations: baseAPI + baseUrl + 'official/week_star/v2/config/gift/durations',
  config_gift_list: baseAPI + baseUrl + 'official/week_star/v2/config/gift/list',
  config_gift_create: baseAPI + baseUrl + 'official/week_star/v2/config/gift/create',
  config_gift_update: baseAPI + baseUrl + 'official/week_star/v2/config/gift/update',
  config_gift_export: baseAPI + baseUrl + 'official/week_star/v2/config/gift/data/export',
  // 周星奖品配置
  config_award_list: baseAPI + baseUrl + 'official/week_star/v2/config/award/list',
  config_award_create: baseAPI + baseUrl + 'official/week_star/v2/config/award/create',
  config_award_update: baseAPI + baseUrl + 'official/week_star/v2/config/award/update',
  config_award_update_valid: baseAPI + baseUrl + 'official/week_star/v2/config/award/update/valid',
  get_const: baseAPI + baseUrl + 'constant/desc/list',
}

const eventCode = 10006

// -------------------- 周星礼物配置 start ---------------------
// 获取周期
export const getGiftDuration = async () => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.config_gift_durations,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}

// 获取礼物列表
export const getWeekGiftList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.config_gift_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      activityType: eventCode,
      ...params
    }
  })
  return res
}

// 创建
export const createWeekGift = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_gift_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      activityType: eventCode,
      operator: store.getters.username,
      ...data
    }
  })
  return res
}

// 更新
export const updateWeekGift = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_gift_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 导出
export const exportWeekGift = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_gift_export,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob',
    data
  })
  return res
}

// -------------------- 周星礼物配置 end ---------------------


// -------------------- 周星奖品配置 start ---------------------
export const getRewardTypeConst = async () => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.get_const,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      className: 'com.quhong.enums.RewardItemType'
    }
  })
  return res
}

export const getWeekRewardList = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.config_award_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode,
      ...params
    }
  })
  return res
}

export const createWeekReward = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_award_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data: {
      ...data,
      eventCode,
      operator: store.getters.username
    }
  })
  return res
}

export const updateWeekReward = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: constApi.config_award_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data

  })
  return res
}

export const updateWeekRewardValid = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi.config_award_update_valid,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}
// -------------------- 周星礼物配置 end ---------------------